import { requests } from ".";
import { SERVICE_NAME } from "@/config/serviceNames";

const OAuthService = {
  Client: {
    Review: {
      //apps
      getAppsForReview: (query?: any) =>
        requests(SERVICE_NAME.OAUTH_API).get(
          `clients/review${
            query ? "?" + new URLSearchParams(query).toString() : ""
          }`
        ),

      getReviewedApps: (query?: any) =>
        requests(SERVICE_NAME.OAUTH_API).get(
          `clients/review/live${
            query ? "?" + new URLSearchParams(query).toString() : ""
          }`
        ),

      getActivityLogs: (id: string, query?: any) =>
        requests(SERVICE_NAME.OAUTH_API).get(
          `clients/${id}/review/comments${
            query ? "?" + new URLSearchParams(query).toString() : ""
          }`
        ),

      createReview: (id: string, data?: any) =>
        requests(SERVICE_NAME.OAUTH_API).post(`clients/${id}/review`, data),

      //custom js
      getScriptsForReview: (query: any) =>
        requests(SERVICE_NAME.OAUTH_API).get(
          `clients/review/custom-script${
            query ? "?" + new URLSearchParams(query).toString() : ""
          }`
        ),

      getScriptActivityLogs: (query: any) =>
        requests(SERVICE_NAME.OAUTH_API).get(
          `clients/review/item-comments${
            query ? "?" + new URLSearchParams(query).toString() : ""
          }`
        ),

      createScriptReview: (id: string, data?: any) =>
        requests(SERVICE_NAME.OAUTH_API).post(
          `clients/review/custom-script/${id}`,
          data
        ),

      updateWhiteLabelStatus: (id: string, payload: any) =>
        requests(SERVICE_NAME.OAUTH_API).post(
          `clients/review/${id}/whitelabelstatus`,
          payload
        ),
    },
  },
};

export default OAuthService;
